<script>
	import { about } from "../lib/stores";
	import AboutBoxItem from "./AboutBox/AboutBoxItem.svelte";
</script>

<p class>
	Dinosol NFTs are a combination of generative dinosaur-themed PFP art, arena
	battle gameplay, and performance-based leaderboard standings.
</p>
<div>&nbsp;</div>
{#each about as item, i}
	<AboutBoxItem title={item.title} content={item.content} />
{/each}
